import * as React from 'react'
import styled from 'styled-components'
import { InlineErrorBoundary } from '../../../common/src/components/InlineErrorBoundary'
import { Spacer, BodyText } from '../../../common/src/components/core'
import xhr from '../../../common/src/data/xhr'
import title from '../../../common/src/title'
import GoogleLogin, { GoogleLoginResponse } from './GoogleLogin'
import WaveAnimation from './components/WaveAnimation'
import LogoAnimated from './header/LogoAnimated'

interface LoginPageProps {
  /**
   * Optional: hide the "wave" animation in the background
   */
  hideAnimation?: boolean
}

interface LoginPageState {
  errorMessage: string | null
}

export default class LoginPage extends React.PureComponent<LoginPageProps, LoginPageState> {
  constructor(props: LoginPageProps) {
    super(props)
    this.state = {
      errorMessage: null,
    }
  }

  componentDidMount() {
    title.set('Login')
  }

  render() {
    const { errorMessage } = this.state

    return (
      <WrapperH>
        <WaveWrapper>
          <InlineErrorBoundary componentName="WaveAnimation">
            ({!this.props.hideAnimation && <WaveAnimation />})
          </InlineErrorBoundary>
        </WaveWrapper>
        <WrapperV>
          <Box>
            <Spacer height={16} />
            <LogoContainer>
              <LogoAnimated />
            </LogoContainer>
            <GoogleLogin onGoogleSignIn={this.handleGoogleLoginSuccess} />
            {errorMessage && (
              <>
                <Spacer height={8} />
                <BodyText color="coral">{errorMessage}</BodyText>
              </>
            )}
            <Spacer height={16} />
          </Box>
        </WrapperV>
      </WrapperH>
    )
  }

  private handleGoogleLoginSuccess = (res: GoogleLoginResponse) => {
    xhr
      .post('/auth/google-login', { ...res })
      .then(() => {
        window.location.reload()
      })
      .catch(this.handleAuthError)
  }

  private handleAuthError = (props: { status: number; responseText: string }) => {
    const { status, responseText } = props
    let errorMessage = null
    if (status === 401 || status === 403) {
      errorMessage = JSON.parse(responseText).message
    } else {
      errorMessage = 'Sorry, a server error occurred'
    }
    this.setState({ errorMessage })
  }
}

const WrapperH = styled.div`
  height: 100vh;
  display: flex;
`

const WrapperV = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
`

const WaveWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

const Box = styled.div`
  width: 512px;
  background-color: rgba(16, 16, 17, 0.9);
  text-align: center;
`

const LogoContainer = styled.div``
